module.exports = __webpack_public_path__ + "fonts/Gotham-BookItalic.58e8934d.otf";